import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-1 pb-3"
}
const _hoisted_2 = {
  key: 0,
  class: "px-1 pb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_PropertiesEditor = _resolveComponent("PropertiesEditor")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "px-2 py-3 align-start scrollbar-hidden",
          style: {"height":"calc(100vh - 52px - 176px)","overflow-y":"auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panels, {
                  variant: "accordion",
                  flat: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "px-2" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode("$fa-file-alt")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.generalThemeSettingsOptions.label), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                          default: _withCtx(() => [
                            (_ctx.generalThemeSettingsOptions.properties)
                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                  key: 0,
                                  perRow: 2,
                                  properties: _ctx.generalThemeSettings.themesList[0].values,
                                  propertiesOptions: _ctx.generalThemeSettingsOptions.properties
                                }, null, 8, ["properties", "propertiesOptions"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_divider, { class: "my-3" }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.generalThemeSettingsOptions.boxStyle.label), 1),
                            (_ctx.generalThemeSettingsOptions.boxStyle.properties)
                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                  key: 1,
                                  properties: _ctx.generalThemeSettings.themesList[0].values.boxStyle,
                                  propertiesOptions: 
                                        _ctx.generalThemeSettingsOptions.boxStyle.properties
                                    
                                }, null, 8, ["properties", "propertiesOptions"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_divider, { class: "my-3" }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.generalThemeSettingsOptions.boxTitleStyle.label), 1),
                            (_ctx.generalThemeSettingsOptions.boxTitleStyle.properties)
                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                  key: 2,
                                  properties: 
                                        _ctx.generalThemeSettings.themesList[0].values.boxTitleStyle
                                    ,
                                  propertiesOptions: 
                                        _ctx.generalThemeSettingsOptions.boxTitleStyle.properties
                                    
                                }, null, 8, ["properties", "propertiesOptions"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_divider, { class: "my-3" }),
                            (_ctx.titleLevels && _ctx.titleLevels.length)
                              ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                  key: 3,
                                  variant: "accordion",
                                  flat: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleLevels, (titleLevel, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (
                                                _ctx.generalThemeSettings.themesList[0].values[
                                                    titleLevel
                                                ]
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_title, { class: "px-2" }, {
                                                  actions: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "x-small" }, {
                                                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                        _createTextVNode("$fa-plus")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", {
                                                      style: _normalizeStyle(
                                                        _ctx.textStyle(
                                                            _ctx.generalThemeSettings.themesList[0]
                                                                .values[titleLevel]
                                                        )
                                                    )
                                                    }, _toDisplayString(_ctx.generalThemeSettingsOptions[titleLevel]
                                                            .label), 5)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                                                  default: _withCtx(() => [
                                                    (
                                                        _ctx.generalThemeSettingsOptions[titleLevel]
                                                            .properties
                                                    )
                                                      ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                          key: 0,
                                                          properties: 
                                                        _ctx.generalThemeSettings.themesList[0].values[
                                                            titleLevel
                                                        ]
                                                    ,
                                                          propertiesOptions: 
                                                        _ctx.generalThemeSettingsOptions[titleLevel]
                                                            .properties
                                                    
                                                        }, null, 8, ["properties", "propertiesOptions"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 256))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "px-2" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_icon, {
                                class: "mr-2 2",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createTextVNode("$fa-chart-bar")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.chartsThemeSettingsOptions.label), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panels, {
                              flat: "",
                              variant: "accordion",
                              outlined: "",
                              value: _ctx.openedChartExpansionPanel
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartsThemeSettings.themesList, (theme) => {
                                  return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                    key: theme.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, {
                                        class: "px-2 d-flex flex-row align-center",
                                        "disable-icon-rotate": ""
                                      }, {
                                        actions: _withCtx(() => [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$oss-edit",
                                            size: "small",
                                            density: "compact"
                                          }),
                                          (theme.id !== 'default')
                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 0,
                                                icon: "$oss-trash",
                                                size: "small",
                                                density: "compact",
                                                class: "ml-2",
                                                onClick: _withModifiers(($event: any) => (_ctx.deleteChartTheme(theme.id)), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { color: "error" })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createElementVNode("strong", null, _toDisplayString(theme.displayName), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                                        default: _withCtx(() => [
                                          (theme.id !== 'default')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: theme.displayName,
                                                  "onUpdate:modelValue": ($event: any) => ((theme.displayName) = $event),
                                                  label: "Nom de la configuration",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  class: "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.chartsThemeSettingsOptions.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 1,
                                                perRow: 2,
                                                properties: theme.values,
                                                propertiesOptions: 
                                                    _ctx.chartsThemeSettingsOptions.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.chartsThemeSettingsOptions.title.label), 1),
                                          (_ctx.chartsThemeSettingsOptions.title.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 2,
                                                perRow: 2,
                                                properties: theme.values.title,
                                                propertiesOptions: 
                                                    _ctx.chartsThemeSettingsOptions.title.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                _createVNode(_component_v_expansion_panel, { class: "d-flex flex-row justify-end" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      dark: "",
                                      color: "primary",
                                      elevation: "0",
                                      rounded: "",
                                      dense: "",
                                      onClick: _ctx.addChartTheme,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          class: "mr-2",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode("$fa-plus")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[4] || (_cache[4] = _createTextVNode(" Nouvelle configuration "))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "d-flex flex-row justify-between px-2" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("$fa-th-list")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.tablesThemeSettingsOptions.label), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panels, {
                              flat: "",
                              variant: "accordion",
                              outlined: "",
                              value: _ctx.openedTablesExpansionPanel
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesThemeSettings.themesList, (theme) => {
                                  return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                    key: theme.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, {
                                        class: "px-2 d-flex flex-row align-center",
                                        "disable-icon-rotate": ""
                                      }, {
                                        actions: _withCtx(() => [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$oss-edit",
                                            size: "small",
                                            density: "compact"
                                          }),
                                          (theme.id !== 'default')
                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 0,
                                                icon: "$oss-trash",
                                                size: "small",
                                                density: "compact",
                                                class: "ml-2",
                                                onClick: _withModifiers(($event: any) => (_ctx.deleteTableTheme(theme.id)), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { color: "error" })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createElementVNode("strong", null, _toDisplayString(theme.displayName), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                                        default: _withCtx(() => [
                                          (theme.id !== 'default')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: theme.displayName,
                                                  "onUpdate:modelValue": ($event: any) => ((theme.displayName) = $event),
                                                  label: "Nom de la configuration",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  class: "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.tablesThemeSettingsOptions.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 1,
                                                perRow: 2,
                                                properties: theme.values,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.header.label), 1),
                                          (_ctx.tablesThemeSettingsOptions.header.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 2,
                                                perRow: 2,
                                                properties: theme.values.header,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.header.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.rows.label), 1),
                                          (_ctx.tablesThemeSettingsOptions.rows.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 3,
                                                perRow: 2,
                                                properties: theme.values.rows,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.rows.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.title.label), 1),
                                          (_ctx.tablesThemeSettingsOptions.title.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 4,
                                                perRow: 2,
                                                properties: theme.values.title,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.title.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.subtotals.label), 1),
                                          (
                                                    _ctx.tablesThemeSettingsOptions.subtotals.properties
                                                )
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 5,
                                                perRow: 2,
                                                properties: theme.values.subtotals,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.subtotals.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.totals.label), 1),
                                          (_ctx.tablesThemeSettingsOptions.totals.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 6,
                                                perRow: 2,
                                                properties: theme.values.totals,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.totals.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.tablesThemeSettingsOptions.footer.label), 1),
                                          (_ctx.tablesThemeSettingsOptions.footer.properties)
                                            ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                key: 7,
                                                perRow: 2,
                                                properties: theme.values.footer,
                                                propertiesOptions: 
                                                    _ctx.tablesThemeSettingsOptions.footer.properties
                                                
                                              }, null, 8, ["properties", "propertiesOptions"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                _createVNode(_component_v_expansion_panel, { class: "d-flex flex-row justify-end" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      dark: "",
                                      color: "primary",
                                      elevation: "0",
                                      rounded: "",
                                      dense: "",
                                      onClick: _ctx.addTableTheme,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          class: "mr-2",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("$fa-plus")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[7] || (_cache[7] = _createTextVNode(" Nouvelle configuration "))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}